import React, {useEffect, useContext} from 'react'
import { getTask } from '../api/operations';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link, useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {WebSocketContext} from '../api/socket';

const AdminTaskSingle = (props) => {
  const { user } = props
  const { task_id } = useParams();
  const ws = useContext(WebSocketContext);
  const [data, setData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
    
  useEffect(() => {
    if (!loaded) {
        reloadData();
        
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const reloadData = () => {
    getTask(task_id).then((r) => {
        setLoaded(true);
        setData(r);
    }).catch((e) => {
        console.log("Error getting operations: ", e);
        setData(null);
        setLoaded(true);
    });
  };

  const onWsTaskUpdate = (data) => {
    let task = data.task;

    if (task.uuid !== task_id) {
        return;
    }

    console.log('[WS] Got task update: ', data.task);
    setData(task);
    
  };

  useEffect(() => {
    if (ws === null) {
        return;
    }
    ws.on('task_update', onWsTaskUpdate);
    return () => {
        ws.off('task_update');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ws]);

    if (!loaded || data === null) {
        return (
            <Grid container spacing={4} justifyContent={"center"}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'stretch',
                                minHeight: 183,
                            }}
                        >
                        <Typography variant='h3' color="text.secondary" gutterBottom>Task {task_id}</Typography>
                        <Typography variant="h5" component="div">Loading...</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        )
    }

  return (
    <Grid container spacing={4} justifyContent={"center"}>
        <Grid item xs={12} md={5}>
            <Card>
                <CardContent
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        minHeight: 183,
                    }}
                >
                <Typography variant='h3' gutterBottom>Task {data.task_id}</Typography>
                <Typography variant="h5" component="div">Status: {data.status}</Typography>
                <Typography sx={{ mt: '5px' }} color="text.secondary">
                Started: {data.started_at}
                </Typography>
                {data.completed_at &&
                <Typography sx={{ mt: '5px' }} color="text.secondary">
                Completed: {data.completed_at}
                </Typography>
                }
                {data.parameters.cluster_id &&
                <Link to={`/admin/cluster/${data.parameters.cluster_id}`}><Typography>Cluster</Typography></Link>
                }
                {data.operation_uuid &&
                <Link to={`/admin/ops/${data.operation_uuid}`}><Typography>Operation</Typography></Link>
                }
                </CardContent>
            </Card>
        </Grid>
        <Grid item xs={12} md={7} lg={7}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    overflow: 'hidden',
                    minHeight: 183,
                }}
            >
            <Typography variant="h3">Task parameters</Typography>
            <pre>{JSON.stringify(data.parameters, null, 2)}</pre>
            </Paper>
        </Grid>
        {data.error &&
        <Grid item xs={12} md={12} lg={12}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    minHeight: 183,
                }}
            >
            <Typography variant="h3" color="danger">Error</Typography>
            <pre>{JSON.stringify(data.error, null, 2)}</pre>
            </Paper>
        </Grid>
    }
        <Grid item xs={12} md={12} lg={12}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    minHeight: 183,
                }}
            >
            <Typography variant="h3">Task result</Typography>
            <pre>{JSON.stringify(data.result, null, 2)}</pre>
            </Paper>
        </Grid>
    </Grid>
  )
}

export default AdminTaskSingle